var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkButton } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { inject } from 'mobx-react';
import { mergeQueryString } from 'bernie-core';
import { withRouter } from 'react-router-dom';
var UitkButtonTracked = ClickTracker(UitkButton);
var LocaleSelectorComponent = /** @class */ (function (_super) {
    __extends(LocaleSelectorComponent, _super);
    // `withRouter` requires constructor to be called
    // eslint-disable-next-line no-useless-constructor
    function LocaleSelectorComponent(props) {
        return _super.call(this, props) || this;
    }
    LocaleSelectorComponent.prototype.selectLocale = function (locale) {
        var location = this.props.location;
        var queryParams = {
            langid: locale.langId
        };
        var queryString = mergeQueryString(location.search, queryParams);
        if (window !== undefined) {
            var url = window.location.href && window.location.href.split('?')[0];
            window.location.href = url + "?" + queryString;
        }
    };
    LocaleSelectorComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, globalComponentsContext = _a.globalComponentsContext, position = _a.position;
        var localeOptions = globalComponentsContext.localeOptions;
        var fontSize = 300;
        return (!localeOptions || localeOptions.length === 0) ? null : (localeOptions.map(function (locale) {
            var displayLanguage = locale.displayLanguage
                ? (locale.displayLanguage.charAt(0).toUpperCase() + locale.displayLanguage.slice(1))
                : '';
            var onClick = function () { return _this.selectLocale(locale); };
            var localeAbbrev = (locale.locale || '').substr(0, 2).toUpperCase();
            var rfrr = "Picker.PWA." + position + "." + localeAbbrev;
            return (React.createElement(UitkButtonTracked, { key: locale.langId, onClick: onClick, trackImmediate: true, linkName: "Save Language", rfrr: rfrr },
                React.createElement(UitkText, { size: fontSize }, displayLanguage)));
        }));
    };
    LocaleSelectorComponent = __decorate([
        inject('globalComponentsContext')
    ], LocaleSelectorComponent);
    return LocaleSelectorComponent;
}(React.Component));
export var LocaleSelector = withRouter(LocaleSelectorComponent);
//# sourceMappingURL=locale-selector.js.map